import React from 'react'

export default function Footer() {
    return (
        <div className='text-white bg-black fs-4 dCenter' style={{height:'5rem'}}>
            <p>Copyright © 2022 HexSchool.All rights reserved.</p>
        </div>
    )
}
